import { ImmomioButtonComponent } from '@immomio/ui/button';
import {
  Component,
  inject,
  input,
  OnInit,
  ChangeDetectionStrategy
} from '@angular/core';
import {
  FormBuilder,
  FormGroup,
  FormsModule,
  ReactiveFormsModule
} from '@angular/forms';
import {
  NgbActiveModal,
  NgbNav,
  NgbNavContent,
  NgbNavItem,
  NgbNavLink,
  NgbNavLinkBase,
  NgbNavOutlet
} from '@ng-bootstrap/ng-bootstrap';

import { CookiePreference } from '@ui/shared/model';
import { TranslatePipe } from '@ngx-translate/core';
import { SvgIconComponent } from 'angular-svg-icon';
import { ModalFooterComponent } from '../../modal/modal-footer/modal-footer.component';

import { ModalContentComponent } from '../../modal/modal-content/modal-content.component';
import { ModalComponent } from '../../modal/modal.component';
import { ThemeService } from '../../../../infrastructure/theme/theme.service';
import { A11yPressDirective } from '../../../../directives/a11y/a11y-press.directive';

@Component({
  selector: 'app-custom-cookie-settings-modal',
  templateUrl: './custom-cookie-settings-modal.component.html',
  styleUrls: ['./custom-cookie-settings-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    ImmomioButtonComponent,
    ModalComponent,
    ModalContentComponent,
    NgbNav,
    NgbNavItem,
    NgbNavLink,
    NgbNavLinkBase,
    NgbNavContent,
    FormsModule,
    ReactiveFormsModule,
    SvgIconComponent,
    NgbNavOutlet,
    ModalFooterComponent,
    TranslatePipe,
    A11yPressDirective
  ]
})
export class CustomCookieSettingsModalComponent implements OnInit {
  private fb = inject(FormBuilder);
  private ngbActiveModal = inject(NgbActiveModal);
  private themeService = inject(ThemeService);

  public form: FormGroup;
  public cookiePreference = input<CookiePreference>(undefined);
  public isTenant = input<boolean>(true);
  public showMoreRequired = false;
  public showMorePerformance = false;
  public showMoreFunctional = false;

  public get logo() {
    return (
      this.theme?.logo?.url || '/assets/images/logos/logo-immomio-main.svg'
    );
  }

  public get theme() {
    return this.themeService.getActiveTheme;
  }

  public ngOnInit() {
    this.form = this.fb.group({
      allowRequired: [true],
      allowFunctional: [false],
      allowPerformance: [false],
      lastUpdated: [null]
    });
    this.form.get('allowRequired').disable();
    if (this.cookiePreference()) {
      this.form.patchValue(this.cookiePreference());
    }
  }

  public save() {
    this.ngbActiveModal.close({
      ...this.form.value,
      lastUpdated: new Date().getTime()
    });
  }

  public acceptAll() {
    this.ngbActiveModal.close({
      allowRequired: true,
      allowFunctional: true,
      allowPerformance: true,
      lastUpdated: new Date().getTime()
    });
  }

  public dismiss() {
    this.ngbActiveModal.dismiss();
  }

  public toggleMoreRequired() {
    this.showMoreRequired = !this.showMoreRequired;
  }

  public toggleMorePerformance() {
    this.showMorePerformance = !this.showMorePerformance;
  }

  public toggleMoreFunctional() {
    this.showMoreFunctional = !this.showMoreFunctional;
  }
}
